import gsap from 'gsap';
import SplitText from '../../../../js/vendors/gsap/SplitText';

gsap.registerPlugin(SplitText);

export class HeroTitle {
    constructor() {
        this.heroTitle = document.getElementById('hero-title');
        this.isDetailsPage = document.querySelector('[data-barba-namespace="city"]') !== null;

        this.init();
    }

    init() {
        this.initText();

        if (this.isDetailsPage) {
            gsap.set(this.heroTitle, {
                height: 0,
                overflow: 'hidden'
            });
        } else {
            if (this.titleCharsInner) {
                gsap.to(this.titleCharsInner, {
                    y: 0,
                    duration: .8,
                    stagger: {
                        amount: 0.5
                    },
                    ease: 'power2.out',
                    delay: 0.2
                });

                if (this.subtitleWordsInner) {
                    gsap.to(this.subtitleWordsInner, {
                        y: 0,
                        duration: .6,
                        stagger: {
                            amount: 0.3
                        },
                        ease: 'power2.out',
                        delay: 1.2
                    });
                }
            }
        }
    }

    initText() {
        this.subtitleEl = this.heroTitle.querySelector('.gom-eyebrow');
        this.titleEl = this.heroTitle.querySelector('h1');

        if(this.titleEl) {
            this.title = new SplitText(this.titleEl, {
                types: 'lines,words,chars',
                charsClass: 'js-letter'
            });

            this.titleChars = this.title.chars;

            this.titleChars.forEach((char) => {
                return char.innerHTML = '<div class="js-inner">' + char.innerHTML + '</div>'
            });

            this.titleCharsInner = [...this.titleEl.querySelectorAll('.js-inner')]

            gsap.set(this.titleCharsInner, {
                y: '100%'
            });
        }

        if(this.subtitleEl) {
            this.subtitle = new SplitText(this.subtitleEl, {
                types: 'words',
                wordsClass: 'js-word'
            });

            this.subtitleWords = this.subtitle.words;

            this.subtitleWords.forEach((word) => {
                word.innerHTML = '<div class="js-inner">' + word.innerHTML + '</div>'
            });

            this.subtitleWordsInner = [...this.subtitleEl.querySelectorAll('.js-inner')]

            gsap.set(this.subtitleWordsInner, {
                y: '100%'
            });
        }
    }

    async animateToIndex() {
        if (!this.heroTitle) return;

        gsap.set(this.heroTitle, {
            height: 'auto',
            overflow: 'hidden'
        });

        const naturalHeight = this.heroTitle.offsetHeight;

        gsap.set(this.heroTitle, {
            height: 0
        });

        await gsap.to(this.heroTitle, {
            height: naturalHeight,
            duration: 0.8,
            ease: 'power2.inOut'
        });

        if (this.titleCharsInner) {
            await gsap.to(this.titleCharsInner, {
                y: 0,
                duration: 1,
                stagger: {
                    amount: 0.02
                },
                ease: 'power2.out',
            });

            if (this.subtitleWordsInner) {
                await gsap.to(this.subtitleWordsInner, {
                    y: 0,
                    duration: 0.6,
                    stagger: {
                        amount: 0.02
                    },
                    ease: 'power2.out',
                });
            }
        }

        gsap.set(this.heroTitle, {
            height: 'auto',
            overflow: ''
        });
    }

    async animateToDetails() {
        if (!this.heroTitle) return;

        const currentHeight = this.heroTitle.offsetHeight;

        gsap.set(this.heroTitle, {
            height: currentHeight,
            overflow: 'hidden'
        });

        const timeline = gsap.timeline();

        if (this.subtitleWordsInner) {
            timeline.to(this.subtitleWordsInner, {
                y: '100%',
                duration: 0.3,
                stagger: 0.01,
                ease: 'power2.in'
            }, 0);
        }

        if (this.titleCharsInner) {
            timeline.to(this.titleCharsInner, {
                y: '100%',
                duration: 0.4,
                stagger: 0.01,
                ease: 'power2.in'
            }, 0);
        }

        timeline.to(this.heroTitle, {
            height: 0,
            duration: 0.8,
            ease: 'power2.inOut'
        }, 0);
    }
}
